// Zero-UI component — listens for studio:fileAssetUploaded events dispatched by
// UploadBox.handleFile (Phase 3b) and registers a file_assets DB record via
// POST /api/file-assets (Phase 5 server route).
// Must be rendered inside ActiveObjectProvider + ActivityProvider.

import { useEffect } from "react";
import { useActiveObject } from "./ActiveObjectProvider.js";
import { useActivity } from "./ActivityProvider.js";
import { registerFileAsset, type FileAssetUploadedPayload } from "./adapters/file_asset_adapter.js";

export function FileAssetListener() {
  const { activeStyleId, activeBomId } = useActiveObject();
  const { emit } = useActivity();

  useEffect(() => {
    async function handle(e: Event) {
      const payload = (e as CustomEvent<FileAssetUploadedPayload>).detail;
      if (!payload || !activeStyleId) return;
      const record = await registerFileAsset(payload, activeStyleId, activeBomId ?? undefined);
      if (record) {
        emit("IMAGE_UPLOADED", `Uploaded to ${payload.slot}`, {
          fileAssetId: record.id,
          slot: payload.slot,
          sourcePanel: payload.sourcePanel,
          styleId: activeStyleId,
        });
      }
    }
    window.addEventListener("studio:fileAssetUploaded", handle);
    return () => window.removeEventListener("studio:fileAssetUploaded", handle);
  }, [activeStyleId, activeBomId, emit]);

  return null;
}
